

/**
 * Top-level tabs are WORKSPACE-scoped, with one exception: `serials`, which is the container for
 * everything scoped to a single state version.
 *
 * That split is the point of this layout. The previous tab set mixed three scopes on one bar -
 * some tabs followed the selected serial, some didn't, and nothing said which - so selecting a
 * version silently changed the meaning of half the bar. Scope is now structural: if it is inside
 * Serials it belongs to one serial, and if it is on this bar it belongs to the workspace.
 */
export type DetailTab = 'overview' | 'runs' | 'serials' | 'lock' | 'providers' | 'policies'

export const DETAIL_TABS: { key: DetailTab; label: string }[] = [
  { key: 'overview',  label: 'Overview' },
  // Next to Overview rather than beside Policies: it is the workspace's narrative, and the first
  // thing wanted when an apply has just failed. Policies remains "what rules apply here".
  { key: 'runs',      label: 'Runs' },
  { key: 'serials',   label: 'Serials' },
  { key: 'lock',      label: 'Lock State' },
  { key: 'providers', label: 'Locked Providers' },
  { key: 'policies',  label: 'Policies' },
]
